import { makeStyles } from "@material-ui/styles";

export default makeStyles({
  helpButton: {
    fontSize:'90%',
    backgroundColor:"#f8da37",
  },
});
